import moment from "moment";
import axiosHttp from "../hooks/intercepter";
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getToken = () => {
  const Token = localStorage.getItem("AccessToken");
  return !!Token ? Token : "";
};

const getAllOrder = async ({ startDate, endDate, selectedStatus, searchText }) => {
  
  // return await axiosHttp.get(`${BASE_URL}/orders`);
  return await axiosHttp.get(`${BASE_URL}/orders`, {
    params: {
      startDate: startDate.toISOString().split("T")[0],
      endDate: endDate.toISOString().split("T")[0],
      // startDate: moment(startDate).format('YYYY-MM-DD'),
      // endDate: moment(endDate).format('YYYY-MM-DD'),
      status: selectedStatus,
      searchText: typeof searchText === 'string' ? searchText.trim() : ''
    },
  });
};

const addOrder = async (formData) => {
  return axiosHttp.post(`${BASE_URL}/order`, formData, {
    method: "POST",
    headers: {
      "ngrok-skip-browser-warning": "true",
      "Content-Type": "application/json"
    },
  });
};

const deleteOrder = async (data) => {
  return axiosHttp.delete(`${BASE_URL}/order/${data._id}`);
};

const getOrderbyId = async (_id) => {
  return axiosHttp.get(`${BASE_URL}/order/${_id}`);
}

const updateOrder = async (data) => {
  return axiosHttp.patch(`${BASE_URL}/order/${data._id}`, data, {
    method: "PATCH",
    headers: {
      "ngrok-skip-browser-warning": "true",
      "Content-Type": "application/json"
    },
  });
};

const addOrderDetails = async (formData) => {
  return axiosHttp.post(`${BASE_URL}/order-details`, formData, {
    method: "POST",
    headers: {
      "ngrok-skip-browser-warning": "true",
      "Content-Type": "application/json"
    },
  });
};


const updateOrderDetails = async (formData) => {
  return axiosHttp.put(`${BASE_URL}/order-details/${formData._id}`, formData, {
    method: "PUT",
    headers: {
      "ngrok-skip-browser-warning": "true",
      "Content-Type": "application/json"
    },
  });
};

export {
  getAllOrder,
  getOrderbyId,
  addOrder,
  updateOrder,
  deleteOrder,

  addOrderDetails,
  updateOrderDetails
};
